/*
 * Default availability.
 * Backend services are be separately managed.
 */
export default {
  '/time': 'stg',
  '/day6': 'stg',
  '/pose-estimate': 'dev',
  '/debug-app': 'dev'
}
